import React, { ReactNode } from 'react'
import styled from 'styled-components'

export interface EyebrowProps {
  children: ReactNode
  className?: string
}

export const Eyebrow: React.FC<EyebrowProps> = ({ children, className }) => (
  <Root className={className}>
    <Dot />
    <Text>{children}</Text>
  </Root>
)
Eyebrow.displayName = 'Eyebrow'

const Root = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  margin-bottom: 1rem;
`

const Dot = styled.span`
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.accent};
  box-shadow: 0 0 0 3px rgba(197, 242, 48, 0.25);
`

const Text = styled.span`
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 0.6875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.ink3};
  text-transform: uppercase;
  letter-spacing: 0.08em;
  white-space: nowrap;
`

export default Eyebrow
